import logger from '../logger';
import fetch, { toQueryString } from '../fetch';

const RestEntityAPI = (options) => {
  const { entityName, endpoint, searchEndpoint } = options;

  const buildEndpoint = (endpoint, parentIds) => (Array.isArray(parentIds) ? endpoint(...parentIds) : endpoint(parentIds));

  const createEntity = async (data, parentIds, query = null) => {
    try {
      const response = await fetch(`${buildEndpoint(endpoint, parentIds)}${toQueryString(query)}`, {
        method: 'POST',
        body: data,
      });
      return response;
    } catch (error) {
      logger.logDebug(`Encountered error while creating ${entityName}`, error);
      throw error;
    }
  };

  const updateEntity = async (id, data, parentIds) => {
    try {
      const response = await fetch(`${buildEndpoint(endpoint, parentIds)}/${id}`, {
        method: 'PATCH',
        body: data,
      });
      return response;
    } catch (error) {
      logger.logDebug(`Encountered error while updating ${entityName}`, error);
      throw error;
    }
  };

  const destroyEntity = async (id, parentIds) => {
    try {
      const response = await fetch(`${buildEndpoint(endpoint, parentIds)}/${id}`, {
        method: 'DELETE',
      });
      return response;
    } catch (error) {
      logger.logDebug(`Encountered error while deleting ${entityName}`, error);
      throw error;
    }
  };

  const getEntity = async (id, parentIds, query = null, fetchOptions = {}) => {
    try {
      const response = await fetch(`${buildEndpoint(endpoint, parentIds)}/${id}${toQueryString(query)}`, {
        ...fetchOptions,
        method: 'GET',
      });
      return response;
    } catch (error) {
      logger.logDebug(`Encountered error while loading ${entityName}`, error);
      throw error;
    }
  };

  const getEntities = async (query, parentIds, fetchOptions = {}) => {
    try {
      const response = await fetch(`${buildEndpoint(endpoint, parentIds)}${toQueryString(query)}`, {
        ...fetchOptions,
        method: 'GET',
      });
      return response;
    } catch (error) {
      logger.logDebug(`Encountered error while loading ${entityName}s`, error);
      throw error;
    }
  };

  const searchEntities = async (query, fetchOptions = {}) => {
    try {
      const response = await fetch(`${searchEndpoint}${toQueryString(query)}`, {
        ...fetchOptions,
        method: 'GET',
      });
      return response;
    } catch (error) {
      logger.logDebug(`Encountered error while searching for ${entityName}s`, error);
      throw error;
    }
  };

  return {
    createEntity,
    updateEntity,
    destroyEntity,
    getEntity,
    getEntities,
    searchEntities,
    buildEndpoint,
    toQueryString,
  };
};

export default RestEntityAPI;
